import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { ReportsCreateModel, ReportsModel, AutomationModel } from 'Pages/advertisement/models'
import { Callback } from 'Src/types/utilTypes'

export type ReportState = {
	requestParams: RequestParams
	reports_list: ResponseCatalog<ReportsModel>
	report: ReportsCreateModel | null
	openedReport: number
	autoReport: AutomationModel | null
	awaitAutomation: boolean
}

export const reportInitialState: ReportState = {
	requestParams: new RequestParams(),
	reports_list: new ResponseCatalog<ReportsModel>(),
	report: null,
	openedReport: null,
	autoReport: null,
	awaitAutomation: false,
}

export namespace reportNS {
	export type getReportList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setRequestParams = PayloadAction<RequestParams>
	export type setReportList = PayloadAction<ResponseCatalog<ReportsModel>>
	export type GetReports = PayloadAction<number>
	export type SetReports = PayloadAction<ReportsCreateModel>
	export type CreateReport = PayloadAction<ReportsCreateModel>
	export type SetReportOpened = PayloadAction<number>
	export type ChangeReportFromSocket = PayloadAction<{
		invoice_id: number
		status: string
		external_id: string
		registered_at: string
	}>

	export type GetCalculate = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetCalculate = PayloadAction<AutomationModel>
	export type SetAwaitAutomation = PayloadAction<boolean>

	export type GetAutogenerate = PayloadAction<{
		data: AutomationModel
	}>
	export type UpdateReports = PayloadAction<{
		id: string
		data: ReportsCreateModel
	}>
}

export const reportsSlice = createSlice({
	name: 'report',
	initialState: reportInitialState,
	reducers: {
		getAll: (state, action: reportNS.getReportList) => {},
		setAll: (state, action: reportNS.setReportList) => {
			state.reports_list = action.payload
		},
		setRequestParams: (state, action: reportNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.reports_list = new ResponseCatalog<ReportsModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: reportNS.GetReports) => {},
		setOne: (state, action: reportNS.SetReports) => {
			state.report = action.payload
		},
		createOne: (state, action: reportNS.CreateReport) => {},
		updateOne: (state, action: reportNS.UpdateReports) => {},
		setOpened: (state, action: reportNS.SetReportOpened) => {
			state.openedReport = action.payload
		},
		changeReportFromSocket: (state, action: reportNS.ChangeReportFromSocket) => {
			const { invoice_id } = action.payload
			const findRepIndex = state.reports_list.entries.findIndex((rep) => rep.id === invoice_id)
			if (findRepIndex) {
				state.reports_list.entries[findRepIndex] = {
					...state.reports_list.entries[findRepIndex],
					...action.payload,
				}
			}
		},
		getCalculate: (state, action: reportNS.GetCalculate) => {},
		setCalculate: (state, action: reportNS.SetCalculate) => {
			state.autoReport = action.payload
		},
		clearCalculate: (state) => {
			state.autoReport = null
		},
		setAwaitAutomation: (state, action: reportNS.SetAwaitAutomation) => {
			state.awaitAutomation = action.payload
		},
		getAutogenerate: (state, action: reportNS.GetAutogenerate) => {},
	},
})
